module.exports = __webpack_public_path__ + "img/20190713124606373.02f62bce.png";